export const settingsSelector = (state) => state.settings;
